/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OAuthAppTypeEnum } from './oAuthAppTypeEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface OAuthAppConfigsResponse { 
    /**
     * Whether the OAuth app secrets are rotatable or not
     */
    rotatable?: boolean;
    /**
     * Secret expiry days
     */
    secret_expiry_days?: number;
    oauth_app_type: OAuthAppTypeEnum;
    service_type: ServiceTypeEnum;
    created_timestamp?: Date;
    created_by?: string;
    updated_timestamp?: Date;
    updated_by?: string;
}
export namespace OAuthAppConfigsResponse {
}


